import React from 'react'

const Home = () => {
    return (
        <div>
            <div style={{marginTop:"30vh"}}>
                <p className='text-center fw-bold' style={{color:"rgb(11, 97, 255)",fontSize:"90pt"}}>404</p>
                <h6 className='text-center fw-bold' style={{color:"rgb(11, 97, 255)", marginTop:"-40px"}}>Halaman Tidak Tersedia</h6>
            </div>
        </div>
    )
}

export default Home